import { render, staticRenderFns } from "./OrderInformationModal.vue?vue&type=template&id=101f947f&"
import script from "./OrderInformationModal.vue?vue&type=script&lang=js&"
export * from "./OrderInformationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports